/**
 * Slider Beneficios LOP
 * - Mobile: rotación de un ítem por vez
 * - Desktop marquee: movimiento continuo con JS en píxeles enteros
 */
(function() {
  function snapToDevicePixel(value) {
    var dpr = window.devicePixelRatio || 1;
    return Math.round(value * dpr) / dpr;
  }

  function destroySection(section) {
    if (!section || !section._sliderBeneficiosState) return;

    var state = section._sliderBeneficiosState;

    section.classList.remove('slider-beneficios-lop--mobile-progress-enabled');

    if (state.mobileInterval) {
      clearInterval(state.mobileInterval);
    }

    if (state.desktopInterval) {
      clearInterval(state.desktopInterval);
    }

    if (state.desktopResetTimeout) {
      clearTimeout(state.desktopResetTimeout);
    }

    if (state.mobileResetTimeout) {
      clearTimeout(state.mobileResetTimeout);
    }

    if (state.mobileProgressFrame) {
      cancelAnimationFrame(state.mobileProgressFrame);
    }

    if (state.marqueeFrame) {
      cancelAnimationFrame(state.marqueeFrame);
    }

    if (state.resizeHandler) {
      window.removeEventListener('resize', state.resizeHandler);
    }

    if (state.desktopResizeHandler) {
      window.removeEventListener('resize', state.desktopResizeHandler);
    }

    section._sliderBeneficiosState = null;
  }

  function getRotationDuration(section) {
    return parseInt(section.getAttribute('data-rotation-seconds'), 10) * 1000 || 5000;
  }

  function initMobileRotation(section, state) {
    var mobileTrack = section.querySelector('.slider-beneficios-lop__mobile-track');
    var items = section.querySelectorAll('.slider-beneficios-lop__mobile-item');
    var progressBar = section.querySelector('.slider-beneficios-lop__mobile-progress-bar');

    if (!mobileTrack || items.length <= 1) {
      section.classList.remove('slider-beneficios-lop--mobile-progress-enabled');
      return;
    }

    var realCount = items.length;
    var duration = getRotationDuration(section);
    var current = 0;
    var isResetting = false;

    var clone = items[0].cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    mobileTrack.appendChild(clone);

    var totalSlots = realCount + 1;

    function setTransform(index, animate) {
      if (animate) {
        mobileTrack.style.transition = 'transform 0.5s cubic-bezier(0.4, 0, 0.2, 1)';
      } else {
        mobileTrack.style.transition = 'none';
      }
      mobileTrack.style.transform = 'translateX(-' + (index * 100 / totalSlots) + '%)';
    }

    mobileTrack.style.width = (totalSlots * 100) + '%';
    var allItems = mobileTrack.querySelectorAll('.slider-beneficios-lop__mobile-item');
    for (var k = 0; k < allItems.length; k++) {
      allItems[k].style.flex = '0 0 ' + (100 / totalSlots) + '%';
      allItems[k].style.minWidth = (100 / totalSlots) + '%';
      allItems[k].style.width = (100 / totalSlots) + '%';
    }

    function advance() {
      if (isResetting) return;

      var next = current + 1;

      if (next <= realCount) {
        current = next;
        setTransform(current, true);

        if (current === realCount) {
          isResetting = true;
          state.mobileResetTimeout = setTimeout(function() {
            current = 0;
            setTransform(0, false);
            isResetting = false;
          }, 550);
        }
      }
    }

    function restartProgress() {
      if (!progressBar) return;

      section.classList.add('slider-beneficios-lop--mobile-progress-enabled');
      progressBar.style.transition = 'none';
      progressBar.style.transform = 'scaleX(0)';

      if (state.mobileProgressFrame) {
        cancelAnimationFrame(state.mobileProgressFrame);
      }

      state.mobileProgressFrame = requestAnimationFrame(function() {
        progressBar.style.transition = 'transform ' + duration + 'ms linear';
        progressBar.style.transform = 'scaleX(1)';
      });
    }

    setTransform(0, false);
    restartProgress();

    state.mobileInterval = setInterval(function() {
      advance();
      restartProgress();
    }, duration);
  }

  function initDesktopRotation(section, state) {
    var track = section.querySelector('.slider-beneficios-lop__desktop-rotator-track');
    var rotator = section.querySelector('.slider-beneficios-lop__desktop-rotator');

    if (!track || !rotator || !section.classList.contains('slider-beneficios-lop--desktop-rotator')) {
      return;
    }

    var duration = getRotationDuration(section);
    var visibleCount = parseInt(getComputedStyle(section).getPropertyValue('--visible-benefit-count'), 10) || 4;
    var desktopBenefitCount = parseInt(getComputedStyle(section).getPropertyValue('--desktop-benefit-count'), 10) || 1;
    var repeatCount = parseInt(getComputedStyle(section).getPropertyValue('--marquee-repeat-count'), 10) || 3;
    var itemWidth = 0;
    var setWidth = 0;
    var current = 0;

    if (desktopBenefitCount <= visibleCount) {
      return;
    }

    function applyTransform(offset, withTransition) {
      track.style.transition = withTransition ? 'transform 0.5s cubic-bezier(0.4, 0, 0.2, 1)' : 'none';
      track.style.transform = 'translate3d(' + (-snapToDevicePixel(offset)) + 'px, 0, 0)';
    }

    function measure() {
      var viewportWidth = rotator.clientWidth;
      var items = track.querySelectorAll('.slider-beneficios-lop__item');

      itemWidth = snapToDevicePixel(viewportWidth / visibleCount);
      setWidth = snapToDevicePixel(itemWidth * desktopBenefitCount);

      items.forEach(function(item) {
        item.style.flex = '0 0 ' + itemWidth + 'px';
        item.style.width = itemWidth + 'px';
      });

      track.style.width = snapToDevicePixel(setWidth * repeatCount) + 'px';
      current = current % desktopBenefitCount;
      applyTransform(setWidth + current * itemWidth, false);
    }

    function goTo(i) {
      var next = i;

      if (next < desktopBenefitCount) {
        current = next;
        applyTransform(setWidth + current * itemWidth, true);
        return;
      }

      applyTransform(setWidth + desktopBenefitCount * itemWidth, true);

      if (state.desktopResetTimeout) {
        clearTimeout(state.desktopResetTimeout);
      }

      state.desktopResetTimeout = setTimeout(function() {
        current = 0;
        applyTransform(setWidth, false);
      }, 550);
    }

    state.desktopResizeHandler = function() {
      measure();
    };

    window.addEventListener('resize', state.desktopResizeHandler);
    measure();

    state.desktopInterval = setInterval(function() {
      goTo(current + 1);
    }, duration);
  }

  function initDesktopMarquee(section, state) {
    var marquee = section.querySelector('.slider-beneficios-lop__marquee');
    var track = section.querySelector('.slider-beneficios-lop__marquee-track');

    if (!marquee || !track || !section.classList.contains('slider-beneficios-lop--desktop-marquee')) {
      return;
    }

    var repeatCount = parseInt(getComputedStyle(section).getPropertyValue('--marquee-repeat-count'), 10) || 3;
    var visibleCount = parseInt(getComputedStyle(section).getPropertyValue('--visible-benefit-count'), 10) || 4;
    var desktopBenefitCount = parseInt(getComputedStyle(section).getPropertyValue('--desktop-benefit-count'), 10) || 1;
    var speedValue = getComputedStyle(section).getPropertyValue('--marquee-speed').trim();
    var durationMs = (parseFloat(speedValue) || 25) * 1000;
    var direction = marquee.classList.contains('slider-beneficios-lop__marquee--right') ? 'right' : 'left';
    var setWidth = 0;
    var itemWidth = 0;
    var offset = 0;
    var lastTs = 0;

    track.style.animation = 'none';

    function measure() {
      var viewportWidth = marquee.clientWidth;
      var items = track.querySelectorAll('.slider-beneficios-lop__item');
      itemWidth = snapToDevicePixel(viewportWidth / visibleCount);
      setWidth = snapToDevicePixel(itemWidth * desktopBenefitCount);

      items.forEach(function(item) {
        item.style.flex = '0 0 ' + itemWidth + 'px';
        item.style.width = itemWidth + 'px';
      });

      track.style.width = snapToDevicePixel(setWidth * repeatCount) + 'px';

      if (!setWidth || !isFinite(setWidth)) return;

      offset = direction === 'right' ? setWidth : 0;
      track.style.transform = 'translate3d(' + (-snapToDevicePixel(offset)) + 'px, 0, 0)';
    }

    function tick(ts) {
      if (!setWidth || window.innerWidth < 768) {
        lastTs = ts;
        state.marqueeFrame = requestAnimationFrame(tick);
        return;
      }

      if (!lastTs) lastTs = ts;

      var delta = ts - lastTs;
      lastTs = ts;
      var pixelsPerMs = setWidth / durationMs;

      if (direction === 'right') {
        offset -= pixelsPerMs * delta;
        if (offset <= 0) offset += setWidth;
      } else {
        offset += pixelsPerMs * delta;
        if (offset >= setWidth) offset -= setWidth;
      }

      var roundedOffset = snapToDevicePixel(offset);
      track.style.transform = 'translate3d(' + (-roundedOffset) + 'px, 0, 0)';

      state.marqueeFrame = requestAnimationFrame(tick);
    }

    state.resizeHandler = function() {
      measure();
    };

    window.addEventListener('resize', state.resizeHandler);
    measure();
    state.marqueeFrame = requestAnimationFrame(tick);
  }

  function initSection(section) {
    destroySection(section);

    var state = {};
    section._sliderBeneficiosState = state;

    initMobileRotation(section, state);
    initDesktopRotation(section, state);
    initDesktopMarquee(section, state);
  }

  function init() {
    var sections = document.querySelectorAll('.slider-beneficios-lop[data-rotation-seconds]');
    sections.forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function(event) {
    var section = event.target.querySelector('.slider-beneficios-lop[data-rotation-seconds]');
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', function(event) {
    var section = event.target.querySelector('.slider-beneficios-lop[data-rotation-seconds]');
    if (section) destroySection(section);
  });
})();
